<div class="agpr-systemNotifications">
    <h1 class="u-srOnly">{{ 'SystemNotifications' | localize }}</h1>
    <section
        class="agpr-systemNotifications-lhp"
        [attr.aria-label]="'Common.layout.lhp' | localize"
    >
        <agpr-button
            [id]="'notifications_openCreateDialog'"
            class="agpr-systemNotifications-lhp-createButton"
            label="SystemNotification.action.create(s)"
            (click)="openCreateDialog()"
            [style]="buttonTypes.primary"
        ></agpr-button>
    </section>
    <section class="agpr-systemNotifications-content">
        <section
            class="agpr-systemNotifications-mainArea"
            [agprLoading]="loading"
            [attr.aria-label]="'Common.layout.main' | localize"
        >
            <p class="agpr-systemNotifications-mainArea-title"> {{ 'SystemNotifications' | localize }} </p>
            <div class="agpr-systemNotifications-mainArea-filter">
                <agpr-filter-dropdown
                    class="agpr-systemNotifications-mainArea-filter-filterDropdown"
                    [id]="'notifications_filters'"
                    [showQuickFilter]="true"
                    [quickFilterPlaceholder]="'SystemNotification.filters.placeholder'"
                    [ariaLabel]="'SystemNotification.filters.label' | localize"
                    [ariaDescribedBy]="'notifications.filters.chips'"
                ></agpr-filter-dropdown>
                <div class="agpr-systemNotifications-mainArea-filter-filterChips">
                    <agpr-filter-chips
                        [id]="'notifications.filters.chips'"
                    ></agpr-filter-chips>
                </div>
            </div>
            <agpr-scroll-panel>
                <div class="agpr-systemNotifications-mainArea-notificationList">
                    <agpr-systems-notifications-card
                        *ngFor="let notification of notificationList; index as i"
                        [id]="'notification_' + i"
                        [notification]="notification"
                        [selectedNotifications]="selectedNotifications"
                        (cardsSelected)="selectedNotifications = $event"
                    ></agpr-systems-notifications-card>
                </div>
            </agpr-scroll-panel>
            <agpr-action-bar class="agpr-systemNotifications-mainArea-actionBar">
                <ng-template #left>
                    <agpr-button
                        [id]="'notifications_deleteButton'"
                        [label]="'SystemNotification.action.delete'"
                        (click)="deleteNotifications()"
                        [disabled]="!selectedNotifications.length"
                    ></agpr-button>
                </ng-template>
            </agpr-action-bar>
        </section>
        <aside
            class="agpr-systemNotifications-rhp"
            [attr.aria-label]="'Common.layout.rhp' | localize"
        >
            <agpr-right-sidebar>
                <agpr-attribute-list
                    [attributes]="notificationDetails"
                ></agpr-attribute-list>
            </agpr-right-sidebar>
        </aside>
    </section>
</div>